<div class="what-is-this-container color-help clickable">
  <fa-icon icon="info-circle" [matTooltip]="tooltip" matTooltipClass="multiline-tooltip"></fa-icon>
</div>
